import * as React from 'react';
import Box from '@mui/material/Box';
import CommonButtonHeader from '../CommonButtonHeader';
import ViewClientSubAccount from './ViewClientSubAccount';

const ClientSubAccountHome = () => {

    return (
        <Box sx={{ width: '100%' }}>
            {/* <CommonButtonHeader /> */}
            <ViewClientSubAccount />
        </Box>
    );
}

export default ClientSubAccountHome